import axios from 'axios'
import Toastify from 'toastify-js'
import 'toastify-js/src/toastify.css'

export default function Denuncia() {
	const form = document.querySelector('#wf-form-Contact-Form-3')
	
	const btnSubmit = form?.querySelector('input[type=submit]')

	form &&
		form.addEventListener('submit', function (event) {
			event.preventDefault()
			disabledBtn()

			// Validação de mínimo de caracteres
			const descricao = form.querySelector('textarea[name="descricao_denuncia"]').value.trim()
			if (descricao.length < 300) {
				showToast('A descrição da denúncia deve ter no mínimo 300 caracteres.')
				enabledBtn()
				return  
			}
  
			// Monta os dados
			const formData = new FormData()
			formData.append('tipo_denuncia', form.querySelector('select[name="tipo_denuncia"]')?.value)
			formData.append('descricao_denuncia', descricao)
			formData.append('data_aproximada_ocorrido', form.querySelector('input[name="data_aproximada_ocorrido"]')?.value)
			formData.append('local_envolvido', form.querySelector('input[name="local_envolvido"]').value)
			formData.append('deseja_se_identificar', form.querySelector('input[name="deseja_se_identificar"]:checked')?.value || '')

			if (form.querySelector('input[name="deseja_se_identificar"]:checked')?.value === 'sim') {
				formData.append('nome_completo', form.querySelector('input[name="nome_completo"]').value)
				formData.append('contato', form.querySelector('input[name="contato"]').value)
			}

			formData.append('aceita_termos', form.querySelector('input[name="aceita_termos"]').checked)

			// Upload de arquivos
			const files = form.querySelector('input[name="arquivo"]').files
			for (let i = 0; i < files.length; i++) {
				formData.append('arquivo', files[i])
			}

			// Envia para o backend
			const url = '/canal-denuncias/' // ajuste conforme sua URL

			axios
				.post(url, formData, {
					headers: {
						'Content-Type': 'multipart/form-data',
					},
				})
				.then((response) => showMessage(response))
				.catch((error) => showMessage(error.response || error))
		})

	function showMessage(response) {
		const identificacao = form.querySelector('input[name="deseja_se_identificar"]:checked')?.value
		const sucesso = response.status === 200 || response.status === 201

		const message = sucesso
			? `Sua denúncia foi registrada com sucesso. Obrigado por sua confiança. Se você se identificou, poderá receber atualizações por e-mail.`
			: response.data?.message || 'Erro ao enviar denúncia. Tente novamente.'

		Toastify({
			text: message,
			duration: 6000,
			gravity: 'top',
			position: 'center',
			stopOnFocus: true,
			style: {
				background: sucesso ? '#51C878' : '#e74c3c',
				color: '#161616',
			},
		}).showToast()

		if (sucesso) {
			form.reset()
			toggleIdentificacao(false)
		}
		enabledBtn()
	}

	function showToast(text) {
		Toastify({
			text,
			duration: 5000,
			gravity: 'top',
			position: 'center',
			stopOnFocus: true,
			style: {
				background: '#facc15',
				color: '#000',
			},
		}).showToast()
	}

	function disabledBtn() {
		btnSubmit.disabled = true
		btnSubmit.value = 'Por favor, aguarde...'
		btnSubmit.classList.add('disabled')
	}

	function enabledBtn() {
		btnSubmit.disabled = false
		btnSubmit.value = 'Enviar'
		btnSubmit.classList.remove('disabled')
	}
}


